import React from 'react';
import {Link} from 'react-router-dom';
import workList from '../db/work.json';


function Works(props) {

    return (
        <>
            <section id="works">
                <div className="wrap flex flex-col">
                    <h3 className="text-5xl pb-4">WORKS</h3>
                    <ul id="project_list" className="pb-4">
                        {Object.values(workList).map(lists=>(
                            lists.map(item=>(
                                <li className="hover:text-cyan-200 relative group" key={item.num}>
                                    <Link to={`/workdetail/${item.param}`} className="flex justify-between text-3xl relative pl-6 py-2 z-10 hover:pl-8 duration-100">
                                        {item.name}
                                        <svg width="75" height="94" viewBox="0 0 95 94" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="17" width="78" height="10"/>
                                            <rect x="85" width="10" height="78"/>
                                            <rect x="85.3555" y="2" width="10" height="120" transform="rotate(45 85.3555 2)" />
                                        </svg>
                                    </Link>
                                    <div className="absolute inset-0 opacity-0 group-hover:opacity-40" style={{backgroundImage:`url('${process.env.PUBLIC_URL}/images/${item.img_main}')`, backgroundPosition:'center center', zIndex:"0"}}></div>
                                </li>
                            ))
                        ))}
                    </ul>
                    <Link to="/workmore" className="text-3xl ms-auto hover:text-cyan-200">MORE</Link>
                </div>
            </section>
        </>
    );
}

export default Works;